export default "__VITE_ASSET__CWIUcnmw__"